import * as React from 'react'
import { useTranslations } from 'next-intl'
import { useUserAuthModal } from 'components/user-auth-dialog/user-auth-dialog-context'
import { Button } from '@repo/design-system-cf/components/button'
import { IconPersonOutline, IconLogin } from '@repo/design-system-cf/components/icons'
import { SkeletonItem } from 'components/skeleton-item'

export function LogoutUserSection() {
  const t = useTranslations('social-feed.components.feed_user_profile_panel')
  const { openModal } = useUserAuthModal()

  return (
    <div>
      <div className="bg-cf-purple-600 flex flex-col items-center px-[14px] p-3 rounded-[12px]">
        <div className="whitespace-pre-wrap text-center text-14 font-semibold text-cf-grey-1000">
          {t('logged_out_title')}
        </div>
        <div className="flex flex-col w-full items-center justify-center rounded-[13px] gap-2 pt-2.5 pb-2">
          <Button
            variant="primary-inverse"
            onClick={() => openModal()}
            aria-label={t('signup_label')}
            iconLeft={<IconPersonOutline />}
            className="w-full"
          >
            {t('signup_label')}
          </Button>
          <Button
            variant="primary-inverse"
            onClick={() => openModal('login')}
            aria-label={t('login_label')}
            iconLeft={<IconLogin />}
            className="w-full"
          >
            {t('login_label')}
          </Button>
        </div>
      </div>
    </div>
  )
}

export function LogoutUserSectionSkeleton() {
  return (
    <div>
      <div className="bg-cf-white flex flex-col items-center px-[14px] p-3 rounded-[12px]">
        {/* Title */}
        <SkeletonItem className="h-10 w-3/4 max-w-[180px] rounded" />

        {/* Buttons row */}
        <div className="flex flex-col w-full items-center justify-center gap-2 pt-2.5 pb-2">
          {/* Sign up button placeholder (icon + label) */}
          <SkeletonItem className="h-9 w-full rounded-[13px]" />
          {/* Login button placeholder (icon + label) */}
          <SkeletonItem className="h-9 w-full rounded-[13px]" />
        </div>
      </div>
    </div>
  )
}
